import React from "react";
import { connect } from "react-redux";
import "../App.css";
import { APP_LOAD, REDIRECT, REQUIRE_AUTH } from "../constants/actionTypes";
import Navigation from "./Navigation";
import Popup from "./Popup";
import Header from "./Header";
import Footer from "./Footer";
import { withRouter } from "react-router";
import * as agent from "../agent";
import Fade from "@material-ui/core/Fade";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Preloader from './Preloader';
import theme from "../constants/theme";

class App extends React.Component {

    componentWillReceiveProps({redirectTo}) {
        if (redirectTo) {
            this.props.history.push(redirectTo);
            this.props.onRedirect();
        }
    }

    startErrorLog() {
        window.onerror = (message, file, line, column, errorObject) => {
            column = column || (window.event && window.event.errorCharacter);
            var stack = errorObject ? errorObject.stack : null;

            if(!stack) {
                var stack = [];
                var f = arguments.callee.caller;
                while (f) {
                    stack.push(f.name);
                    f = f.caller;
                }
                errorObject["stack"] = stack;
            }

            var data = {
                source: "CLIENT",
                message: message,
                file: file,
                line: line,
                column: column,
                errorStack: stack,
            };

            agent.CustomError.add(data)

            return false;
        }
    }

    componentWillMount() {
        this.startErrorLog();
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true; // hide MUI console warnings
        const token = window.localStorage.getItem("jwt");
        if (token) {
            agent.setToken(token);
            agent.Auth.current()
                .then(res => this.props.onLoad(res, token))
                .catch(err => {
                    if (err instanceof agent.AuthError) {
                        window.localStorage.removeItem("jwt");
                        agent.setToken(null);
                        this.props.requireAuth();
                        this.props.onLoad();
                        return null;
                    }
                    return err;
                });
        } else {
            this.props.onLoad();
        }
    }

    render() {
        const { appLoaded, user, children, showMessage, location: {pathname} = {} } = this.props;
        const minifiedInterface = window.localStorage.getItem("minifiedInterface") === "true";
        return appLoaded ? (
            <MuiThemeProvider theme={createMuiTheme(theme)}>
                <Fade in={appLoaded}>
                    <React.Fragment>
                        {!minifiedInterface && <Header />}
                        <div className="app-root">
                            {user && <Navigation user={user} path={pathname} />}
                            <main className="app-content">
                                {children}
                            </main>
                            {showMessage && <Popup />}
                        </div>
                        {!minifiedInterface && <Footer />}
                    </React.Fragment>
                </Fade>
            </MuiThemeProvider>
        ) : <Preloader size="l"/>;
    }
}

const mapStateToProps = state => ({
    appLoaded: state.common.appLoaded,
    user: state.common.user,
    redirectTo: state.common.redirectTo,
    showMessage: state.common.showMessage,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload = null, token = null) =>
        dispatch({type: APP_LOAD, payload, token}),
    onRedirect: () =>
        dispatch({type: REDIRECT}),
    requireAuth: () =>
        dispatch({ type: REQUIRE_AUTH, prevPath: window.location.pathname}),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js